import { getWindow } from '../general';
export var redirectToDownloadsPage = function (redirectedFrom, setBtnLoading) {
    setTimeout(function () {
        var _a, _b;
        if (setBtnLoading)
            setBtnLoading(false);
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem(redirectedFrom, 'true');
        (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.location.assign('/myaccount/downloads');
    }, 3000);
};
export var clearRedirectFlags = function () {
    var _a, _b;
    (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.removeItem('linkedAccountsRedirect');
    (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.sessionStorage.removeItem('orderHistoryRedirect');
};
